import { dutyColumns } from "../closed/dutyColumns";

export const draftColumns = [
  { id: "ordered_quantity", title: "Ordered" },
  { id: "oos_date", title: "Stockout date" },
  { id: "margin", title: "Margin" },
  { id: "price", title: "Price" },
  { id: "pack_size", title: "Pack size" },
  { id: "warehouse_location", title: "Warehouse location" },
  { id: "min", title: "Min quantity" },
  { id: "supplier_sku", title: "Vendor / supplier SKU" },
] as const;

export type DraftColumn = (typeof draftColumns)[number];

export const orderedColumns = [
  { id: "warehouse_location", title: "Warehouse location" },
  { id: "currently_available", title: "Available", tooltipContent: "Currently available at the destination" },
  { id: "received_total", title: "Total received" },
] as const;

export type OrderedColumn = (typeof orderedColumns)[number];

export const closedColumns = [
  ...dutyColumns,
  { id: "price", title: "Price" },
  { id: "margin", title: "Margin" },
  { id: "received_total", title: "Total received" },
] as const;
